import * as querystring from 'query-string';
import { parseAppQueryParams } from '../../../utils/url';

export const getQuerySearchWithCoupon = (coupon: string | null) => {
  const params = parseAppQueryParams();
  return `?${querystring.stringify({ ...params, coupon: coupon || undefined }, { encode: true })}`;
};
